// Roving focus for the homepage's horizontal tab controls. Arrow keys activate
// immediately; Tab leaves the control. Home/End reach the first/last choice.
export function navigateTabs(event: KeyboardEvent, index: number, count: number, select: (index: number) => void) {
  const offsets: Record<string, number> = { ArrowRight: 1, ArrowLeft: -1 };
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1
    : event.key in offsets ? (index + offsets[event.key] + count) % count : null;
  if (next === null) return;
  event.preventDefault();
  const tablist = (event.currentTarget as HTMLElement).closest('[role="tablist"]');
  select(next);
  (tablist?.querySelectorAll('[role="tab"]')[next] as HTMLElement | undefined)?.focus();
}
